import { defineComponent as _defineComponent } from 'vue'
import EditIcon from '@/components/molecules/EditIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsContractEditHeadline',
  props: {
  title: {
    type: String,
    default: ''
  },
  subtitle: {
    type: String,
    default: ''
  },
  notes: {
    type: String,
    default: ''
  },
  showEdit: {
    type: Boolean,
    default: true
  }
},
  setup(__props) {



return { __sfc: true,EditIcon }
}

})